export default "__VITE_ASSET__BgR9lRCd__"